export default function DurationDisplay({ seconds, format = 'compact' }) {
  if (!seconds && seconds !== 0) return <span className="text-dark-500">—</span>;

  const totalSec = parseFloat(seconds);

  if (isNaN(totalSec)) return <span className="text-dark-500">—</span>;

  if (format === 'compact') {
    if (totalSec < 60) {
      return <span>{Math.round(totalSec)}s</span>;
    }
    const mins = Math.floor(totalSec / 60);
    const secs = Math.round(totalSec % 60);
    if (mins < 60) {
      return <span>{mins}:{secs.toString().padStart(2, '0')}</span>;
    }
    const hours = Math.floor(mins / 60);
    const remainingMins = mins % 60;
    if (hours < 24) {
      return <span>{hours}:{remainingMins.toString().padStart(2, '0')}:{secs.toString().padStart(2, '0')}</span>;
    }
    return <span>{hours}h {remainingMins}m</span>;
  }

  // Full format
  const hours = Math.floor(totalSec / 3600);
  const mins = Math.floor((totalSec % 3600) / 60);
  const secs = Math.round(totalSec % 60);
  return (
    <span>
      {hours > 0 ? `${hours}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}` : `${mins}:${secs.toString().padStart(2, '0')}`}
    </span>
  );
}

export function formatBitrate(bitrate) {
  if (!bitrate) return '—';
  if (bitrate >= 1000) return `${(bitrate / 1000).toFixed(1)} Mbps`;
  return `${bitrate} kbps`;
}

export function formatFileSize(bytes) {
  if (!bytes) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}
